import React from "react";
import propTypes from "prop-types";
import icons from "./Icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./Icon.scss";
import { createDataAttributes } from "../../utilities";

const IconNames = Object.keys(icons);

const Icon = React.memo(
  ({ icon, size, className, onClick, dataAttrib, ...rest }) => {
    const theIcon = (
      <FontAwesomeIcon
        size={size}
        icon={icons[icon]}
        className={className}
        {...createDataAttributes(dataAttrib)}
        {...rest}
      />
    );

    if (onClick)
      return (
        <button type="button" className="uikit__icon-btn" onClick={onClick}>
          {theIcon}
        </button>
      );

    return theIcon;
  }
);

Icon.displayName = "Icon";
Icon.icons = IconNames;

Icon.propTypes = {
  className: propTypes.string,
  icon: propTypes.oneOf(IconNames).isRequired,
  size: propTypes.oneOf([
    "xs",
    "sm",
    "md",
    "lg",
    "1x",
    "2x",
    "3x",
    "4x",
    "5x",
    "6x",
    "7x",
    "8x",
    "9x",
    "10x"
  ]),
  dataAttrib: propTypes.arrayOf(Object),
  onClick: propTypes.func,
  buttonProps: propTypes.object
};

Icon.defaultProps = {
  size: "1x"
};

export default Icon;
